import React from 'react';
import { Modal, Box } from '@mui/material';

interface ImagePreviewModalProps {
  open: boolean;
  imageUrl: string;
  alt?: string;
  onClose: () => void;
}

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  outline: 'none',
  p: 1,
  borderRadius: 2,
  maxWidth: '90vw',
  maxHeight: '90vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({ open, imageUrl, alt, onClose }) => (
  <Modal open={open} onClose={onClose} aria-labelledby="image-preview-modal">
    <Box sx={style}>
      <img
        src={imageUrl}
        alt={alt || 'Preview'}
        style={{
          maxWidth: '80vw',
          maxHeight: '80vh',
          objectFit: 'contain',
          borderRadius: 8,
          background: '#f5f5f5',
        }}
      />
    </Box>
  </Modal>
);

export default ImagePreviewModal;
